import LocalPhoneIcon from "@mui/icons-material/LocalPhone"

import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationChannelPhoneIcon({
  padding = 0,
  size = "16px",
  fontSize = "13px"
}: {
  padding?: number
  size?: string
  fontSize?: string
}) {
  return (
    <IconWrapper
      sx={{
        backgroundColor: "#44D64F",
        borderRadius: "20%",
        padding,
        width: size,
        height: size
      }}
    >
      <LocalPhoneIcon sx={{ fontSize: fontSize, color: "#fff" }} />
    </IconWrapper>
  )
}
